export const isHTMLTags = (value: string) => {
    // eslint-disable-next-line
    return value.match(/([\<])([^\>]{1,})*([\>])/i);
};
